import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScNewBlackjackReady implements ICommand
{

	public HostID : number = 0;
	public GameID : number = 0;
	public GameCount : number = 0;
	public JSON : string = "";

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.GameID = ba.readUint53();
		this.GameCount = ba.readUint32();
		this.JSON = ba.readString();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		ba.writeUint53(this.GameID);
		ba.writeUint32(this.GameCount);
		ba.writeString(this.JSON);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScNewBlackjackReady();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'GameCount(D)='+this.GameCount+' ';
		str += 'JSON(S)='+this.JSON+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30053;
	}

	public getCmdName() : string
	{
		return 'ScNewBlackjackReady';
	}

}
